import api from '.';

const base = '/pocos';
export async function consultar(recurso, params = {}, config = {}) {
    const query = { ...params };
    for (const key of ['filters', 'filtersMode', 'sorting']) {
        if (query[key] != null && typeof query[key] !== 'string') query[key] = JSON.stringify(query[key]);
    }

    const { data } = await api.get(`${base}/${recurso}`, { ...config, params: query });

    return data;
}
export async function gravar(recurso, dados) {
    const { data } = await api.post(
        `${base}/${recurso}`,
        dados,
        dados instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined
    );
    if (data.type !== 'success') throw new Error(data.message || 'Não foi possível salvar.');
    return data;
}
// Seletores precisam do histórico completo: a API limita cada página a 200.
export async function opcoes(recurso, produtoBensId, signal) {
    const rows = [];
    let total;
    do {
        const data = await consultar(
            `${recurso}/listar`,
            {
                produtoBensId,
                start: rows.length,
                size: 200,
                sorting: [{ id: 'id', desc: false }],
            },
            { signal }
        );
        if (!Array.isArray(data.dados)) throw new Error('Resposta inválida na consulta de opções.');
        total = Number(data.total);
        if (!Number.isFinite(total) || (!data.dados.length && rows.length < total))
            throw new Error('Consulta de opções incompleta. Atualize a tela.');
        rows.push(...data.dados);
    } while (rows.length < total);
    return rows;
}
export async function anexar(destino, categoria, arquivos, observacao) {
    const form = new FormData();
    Object.entries(destino).forEach(([key, value]) => form.append(key, value));
    form.append('categoria', categoria);
    form.append('observacao', observacao || '');
    arquivos.forEach((file) => form.append('arquivos', file));
    return gravar('arquivos/anexar', form);
}
export async function obterArquivo(uuid, download = false) {
    const response = await api.get(`${base}/arquivos/${encodeURIComponent(uuid)}`, {
        responseType: 'blob',
        params: download ? { download: 1 } : {},
    });
    return response.data;
}

// Reutiliza a mesma serialização da listagem, sem [object Object].
export async function relatorio(recurso, params, config = {}) {
    try {
        return await consultar(`${recurso}/relatorio`, params, { ...config, responseType: 'blob' });
    } catch (e) {
        const blob = e.response?.data;
        if (blob instanceof Blob) {
            try { e.response.data = JSON.parse(await blob.text()); } catch { /* mantém erro original */ }
        }
        throw e;
    }
}
